// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";

function optionToText(option) {
  switch (option) {
    case "Transport" :
      return I18n.t("Transport");
    case "Taxes" :
      return I18n.t("Taxes");
    case "Other" :
      return I18n.t("Other");
  }
}

export {
  optionToText,
}
/* I18n Not a pure module */
